<script>
  export let active;
</script>

<div id="hamburger" class={active ? "open" : ""}>
  <span />
  <span />
  <span />
</div>

<style>
  #hamburger {
    width: 40px;
    height: 35px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.5s ease-in-out;
    -moz-transition: 0.5s ease-in-out;
    -o-transition: 0.5s ease-in-out;
    transition: 0.5s ease-in-out;
    cursor: pointer;
  }

  #hamburger span {
    display: block;
    position: absolute;
    height: 4px;
    width: 100%;
    background: #ed1c24;
    border-radius: 4px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.25s ease-in-out;
    -moz-transition: 0.25s ease-in-out;
    -o-transition: 0.25s ease-in-out;
    transition: 0.25s ease-in-out;
    margin: 1rem;
  }

  #hamburger span:nth-child(1) {
    top: 0px;
  }

  #hamburger span:nth-child(2) {
    top: 10px;
  }

  #hamburger span:nth-child(3) {
    top: 20px;
  }

  #hamburger.open span:nth-child(1) {
    top: 18px;
    -webkit-transform: rotate(135deg);
    -moz-transform: rotate(135deg);
    -o-transform: rotate(135deg);
    transform: rotate(135deg);
  }

  #hamburger.open span:nth-child(2) {
    opacity: 0;
    left: -60px;
  }

  #hamburger.open span:nth-child(3) {
    top: 18px;
    -webkit-transform: rotate(-135deg);
    -moz-transform: rotate(-135deg);
    -o-transform: rotate(-135deg);
    transform: rotate(-135deg);
  }
</style>
